import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './custom.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router basename='/'>
        <App />
        <ToastContainer position='top-right' theme='colored' autoClose={2000} />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
